import { CreditCardType, PaymentClass } from 'generated/graphql';

import { mapCardBrandToCreditCardType } from 'helpers/offlineTerminal/mapCardBrandToMenuX';



/** Same mapping as creditCardEnum() in Payment.tsx / BillSettlement.tsx */

function creditCardLabelToEnum(label?: string | null): CreditCardType | undefined {

	if (!label) return undefined;



	if (label === 'American Express Card') {

		return CreditCardType.AmericanExpressCard;

	}

	if (label === 'Diners Card') return CreditCardType.DinersCard;

	if (label === 'JCB Card') return CreditCardType.JcbCard;

	if (label === 'Master Card') return CreditCardType.Mastercard;

	if (label === 'UNION PAY') return CreditCardType.UnionpayCard;

	if (label === 'Visa Card') return CreditCardType.VisaCard;

	if (label === 'Debit Card') return CreditCardType.DebitCard;

	if (label === 'E-Wallet') return CreditCardType.Ewallet;



	return mapCardBrandToCreditCardType(label) ?? undefined;

}



/**

 * Resolve creditCardType for GraphQL paymentInput from ECR or manual form values.

 */

export function resolvePaymentCreditCardType(

	paymentRow: Record<string, unknown> | undefined,

	formCardType: unknown,

): CreditCardType | undefined {

	if (
		String(paymentRow?.paymentClass || '').toUpperCase() !== PaymentClass.Credit
	) {
		return undefined;
	}



	if (paymentRow?.creditCardType) {

		const rowType = paymentRow.creditCardType;

		if (Object.values(CreditCardType).includes(rowType as CreditCardType)) {

			return rowType as CreditCardType;

		}

		return (

			creditCardLabelToEnum(String(rowType)) ??

			mapCardBrandToCreditCardType(String(rowType)) ??

			undefined

		);

	}



	if (

		formCardType != null &&

		typeof formCardType === 'object' &&

		(formCardType as { GuestType?: string }).GuestType != null

	) {

		return creditCardLabelToEnum(

			(formCardType as { GuestType?: string }).GuestType,

		);

	}



	if (!formCardType) return undefined;



	if (Object.values(CreditCardType).includes(formCardType as CreditCardType)) {

		return formCardType as CreditCardType;

	}



	if (typeof formCardType === 'string') {

		return (

			creditCardLabelToEnum(formCardType) ??

			mapCardBrandToCreditCardType(formCardType) ??

			undefined

		);

	}



	return undefined;

}

/** RegistrationID from HotelX CARD debtor selected in Card Type (object value). */
export function registrationIDFromCreditCardType(
	formCardType: unknown,
): string | undefined {
	if (
		formCardType != null &&
		typeof formCardType === 'object' &&
		(formCardType as { RegistrationID?: string }).RegistrationID
	) {
		return (formCardType as { RegistrationID?: string }).RegistrationID;
	}
	return undefined;
}

/** While city ledger is on, wait for debtor list before showing card options / confirm. */
export function isCreditPaymentWaitingForDebtorList(
	integrateCityLedger: boolean | undefined,
	isDebtorListLoading: boolean,
): boolean {
	return integrateCityLedger === true && isDebtorListLoading;
}


